export default __webpack_public_path__ + "static/media/god-generate-preview2.9505fcf0.png";